import React, { useEffect, useState } from 'react';
import { Modal, Typography, Spin, message, Timeline, Tag, Tooltip } from 'antd';
import { ThunderboltOutlined } from '@ant-design/icons';
import axios from '../../config/axiosInstance';
import moment from 'moment';

const { Text } = Typography;

const ModalBatteryHistory = ({ open, onClose, device }) => {
    const [loading, setLoading] = useState(false);
    const [batteryHistory, setBatteryHistory] = useState([]);

    useEffect(() => {
        if (!open || !device?._id) return;

        const fetchBatteryHistory = async () => {
            setLoading(true);
            try {
                const response = await axios.get(`/devices/${device._id}/battery-history`);
                const sorted = response.data
                    .sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));
                setBatteryHistory(sorted);
            } catch (err) {
                message.error('Error fetching battery history');
            } finally {
                setLoading(false);
            }
        };

        fetchBatteryHistory();
    }, [open, device]);

    return (
        <Modal
            title={`Battery History - ${device?.Name || 'Device'}`}
            open={open}
            onCancel={onClose}
            footer={null}
            width={700}
        >
            <div style={{ marginTop: 30 }}>
                {loading ? (
                    <Spin />
                ) : batteryHistory.length > 0 ? (
                    <Timeline mode="alternate">
                        {batteryHistory.map(entry => {
                            const isCharging = entry.state === 'Charging';
                            return (
                                <Timeline.Item
                                    key={entry._id}
                                    position={isCharging ? 'right' : 'left'}
                                    color={isCharging ? 'orange' : 'blue'}
                                >
                                    <Text strong>{moment(entry.timestamp).format('HH:mm:ss')}</Text>{' '}
                                    <Tag color={entry.level >= 50 ? 'green' : entry.level >= 20 ? 'orange' : 'red'}>
                                        {entry.level}%
                                    </Tag>{' '}
                                    {isCharging ? (
                                        <Tooltip title="Charging">
                                            <Tag icon={<ThunderboltOutlined />} color="orange">
                                                Charging
                                            </Tag>
                                        </Tooltip>
                                    ) : (
                                        <Tag>{entry.state || 'Unknown'}</Tag>
                                    )}
                                </Timeline.Item>
                            );
                        })}
                    </Timeline>
                ) : (
                    <Text type="secondary">No battery data for today.</Text>
                )}
            </div>
        </Modal>
    );
};

export default ModalBatteryHistory;